export default __webpack_public_path__ + "static/media/gallery - prince vs clean_02.67808028.jpg";